/**
 * 排出事業者の検索ダイアログ
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'
import * as types from '../../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/trader_details`

const master_search_trader_detail = {
  namespaced: true,
  actions: {
    /**
     *
     * @param commit
     * @param params
     * @property mode { string } モード: trader or traderLocation
     * @property code { string } 事業場コード
     * @property subscriber_no { string } 加入者番号
     * @property name { string } 名称
     * @property zip_code { string } 郵便番号
     * @property prefecture_code { string } 都道府県コード
     * @property address { string } 住所
     * @property phone_number { string } 電話番号
     * @property page { number } ページ番号
     * @return {Promise<unknown>}
     */
    index ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  },
}

export default master_search_trader_detail
